import adminLogin from "@/views/admin/adminLogin.vue";
import { createRouter, createWebHashHistory } from "vue-router";
import adminTable from "@/views/main/adminTable.vue";
import testTable from "@/views/main/testTable.vue";
import mainTable from "@/views/main/mainTable.vue";
import wordTable from "@/views/main/wordTable.vue";
import feedbackTable from "@/views/main/feedbackTable.vue";
import roleTable from "@/views/main/roleTable.vue";
import promotionTable from "@/views/main/promotionTable.vue";
import wordDetailTable from "@/views/main/wordDetailTable.vue";
import systemManage from "@/views/main/systemManage.vue";
import reviewRewardTable from "@/views/main/reviewRewardTable.vue";
const routes = [
  {
    path: "/",
    component: adminTable,
    name: "adminTable",
    redirect: "/mainTable",
    meta: { authRequired: true },
    children: [
      {
        path: "/mainTable",
        component: mainTable,
      },
      {
        path: "/testTable",
        component: testTable,
      },
      {
        path: "/feedbackTable",
        component: feedbackTable,
      },

      {
        path: "/wordTable",
        component: wordTable,
      },
      {
        path: "/roleTable",
        component: roleTable,
      },
      {
        path: "/promotionTable",
        component: promotionTable,
      },
      {
        path: "/reviewRewardTable",
        component: reviewRewardTable,
      },
      {
        path: "/wordDetailTable",
        component: wordDetailTable,
      },
      {
        path: "/systemManage",
        component: systemManage,
      },
    ],
  },
  {
    path: "/login",
    name: "login",
    component: adminLogin,
  },
];

const router = createRouter({
  base: "/",
  // history: createWebHistory(),
  history: createWebHashHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("m-token");
  if (to.name !== "login" && !token) next({ name: "login" });
  else next();
});

export default router;
